var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.1369 64.7161C51.2452 64.7161 64.3035 51.6577 64.3035 35.5494C64.3035 19.4411 51.2452 6.38275 35.1369 6.38275C19.0286 6.38275 5.97021 19.4411 5.97021 35.5494C5.97021 51.6577 19.0286 64.7161 35.1369 64.7161Z",
    fill: "#62CF7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9949 45.9911C30.4116 45.9911 29.8574 45.7578 29.4491 45.3494L21.1949 37.0953C20.3491 36.2494 20.3491 34.8494 21.1949 34.0036C22.0408 33.1578 23.4408 33.1578 24.2866 34.0036L30.9949 40.7119L45.9866 25.7203C46.8324 24.8744 48.2324 24.8744 49.0783 25.7203C49.9241 26.5661 49.9241 27.9661 49.0783 28.8119L32.5408 45.3494C32.1324 45.7578 31.5783 45.9911 30.9949 45.9911Z",
    fill: "#62CF7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.a11cc1de911339c428a14176cdae72fd.svg";
export { ForwardRef as ReactComponent };